import TrashieContainerPublicCentered from './TrashieContainerPublicCentered';

export default TrashieContainerPublicCentered;
